
//// ** Export Backend Url 
//
export const BackendUrl = () => "https://dirigohubbackend.azurewebsites.net"  ////Azure Dirigo Hub Backend
//export const BackendUrl = () => "http://localhost:4000"                       ////Old localhost
//export const BackendUrl = () => "http://localhost:5000"                       ////New localhost
//export const BackendUrl = () => "https://dirigohubbackend-liveslot03102024.azurewebsites.net/" //Azure Dirigo Hub Backend Test Slot